import { TextField } from '@mui/material';
import { Component } from 'react';

export default class ProdNomeInput extends Component {
    render() {
        return (
            <TextField
                {...this.props.props}
                sx={this.props.sx}
                error={this.props.error === true}
                helperText={this.props.error === true ? "Informe um nome" : null}
                size="small"
                variant="outlined"
                name="nome"
                label={'Nome do produto' + (this.props.required ? '*': '')}
                value={this.props.value?.toUpperCase().replace(/[^A-Z0-9\u00C0-\u00FF ]/g, ' ')}
                onChange={e => this.props.onChange ? this.props.onChange(e.target.value.toUpperCase()) : {}} />
        );
    }
}